<img class="position-fixed bottom-0 end-0 img-fluid mh-35-vh-resp o-5" src="../../../assets/img/Locana-person-icon.svg" alt="LoCana">

<app-init-navbar></app-init-navbar>

<div class="bg-primary init-bg d-flex justify-content-center align-items-center overflow-auto">
    <router-outlet></router-outlet>
    <!-- <app-init-footer></app-init-footer> -->
</div>